import * as angular from 'angular';
import * as angularTranslate from 'angular-translate';

import { SidePanelModule } from '../side-panel';
import { sessionManager } from '../session-manager';
import { csvReportModule } from 'go-modules/csv-report';

import { ActivityReportPanelService } from './activity-report-panel.service';
import { downgradeComponent } from '@angular/upgrade/static';
import { ActivityReportComponent } from '@go-modules/components/activity-report/activity-report.component';
import { ActivityReportOldComponent } from '@go-modules/components/activity-report/old/activity-report-old.component';

import './style.less';

export const activityReportPanelModule = angular.module('activity-report-panel', [
	angularTranslate,
	SidePanelModule,
	sessionManager,
	csvReportModule
])
	.directive('ngxActivityReportOld', downgradeComponent({ component: ActivityReportOldComponent }))
	.directive('ngxActivityReport', downgradeComponent({ component: ActivityReportComponent }))
	.service(ActivityReportPanelService.NG1_INJECTION_NAME, ActivityReportPanelService);
